module.exports = __webpack_public_path__ + "static/media/ZhiXiao2.ecc4a8b9.png";